import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-settings4-icon',
  templateUrl: './code-settings4.component.html'
})
export class CodeSettings4Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
